export default __webpack_public_path__ + "static/media/modal-2019.6923d4aa.pdf";